import CancelIcon from '@mui/icons-material/Cancel';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  Autocomplete,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AxiosConfig from '../../../config/AxiosConfig';

const CategorizationElem = ({ _profile, _contentTab, elem, mutate }) => {
  const navigate = useNavigate();
  const services = useSelector((state) => state?.static?.services);
  const ticketTypes = useSelector((state) => state?.static?.ticketTypes);
  const [isEditableElement, setIsEditableElement] = useState(false);
  const [name, setName] = useState(elem?.name);
  const [technicalName, setTechnicalName] = useState(elem?.technicalName);
  const [service, setService] = useState(elem?.service);
  const [ticketType, setTicketType] = useState(elem?.ticketType);

  useEffect(() => {
    if (elem) {
      setName(elem?.name);
      setTechnicalName(elem?.technicalName);
      setService(elem?.service);
      setTicketType(elem?.ticketType);
    }
  }, [elem]);

  const handleEditableElement = () => {
    setIsEditableElement((state) => !state);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleServiceChange = (event, value) => {
    setService(value);
    setTicketType(null);
  };

  const handleTicketTypeChange = (event, value) => {
    setTicketType(value);
  };

  const handleNavigateToProject = (projectId, ticketId) => {
    navigate(`/project/${projectId}/tickets/${ticketId}/activities`);
  };

  const handleCancelModification = () => {
    setIsEditableElement((state) => !state);
    if (elem) {
      setName(elem?.name);
      setTechnicalName(elem?.technicalName);
      setService(elem?.service);
      setTicketType(elem?.ticketType);
    }
  };

  const handleConfirmModification = () => {
    setIsEditableElement((state) => !state);
    AxiosConfig.create('put', `/categorizations/${elem?._id}`)
      .call({
        name: name,
        serviceId: service?._id,
        ticketTypeId: ticketType?._id,
      })
      .exit((_res) => {
        mutate();
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
        <TableCell>{technicalName}</TableCell>
        <TableCell>
          {!isEditableElement ? (
            <>{name}</>
          ) : (
            <>
              <TextField value={name} onChange={handleNameChange} />
            </>
          )}
        </TableCell>
        <TableCell>
          {!isEditableElement ? (
            <>{service?.code}</>
          ) : (
            <>
              <Autocomplete
                id="select-service"
                options={services?.filter(
                  (service) =>
                    ['SCO', 'SLO', 'SAV'].indexOf(service?.code) !== -1
                )}
                getOptionLabel={(option) => {
                  return `${option?.code} - ${option?.name}`;
                }}
                isOptionEqualToValue={(option, value) => {
                  if (option && value) {
                    return option?._id === value?._id;
                  }
                  return false;
                }}
                filterOptions={(options, _state) => options}
                value={service}
                onChange={handleServiceChange}
                sx={{ width: 250 }}
                disableClearable={true}
                renderInput={(params) => <TextField {...params} />}
              />
            </>
          )}
        </TableCell>
        <TableCell>
          {!isEditableElement ? (
            <>{ticketType?.name}</>
          ) : (
            <>
              <Autocomplete
                id="select-tickettype"
                options={ticketTypes?.filter(
                  (ticketType) => ticketType?.service?._id === service?._id
                )}
                getOptionLabel={(option) => {
                  return `${option?.name}`;
                }}
                isOptionEqualToValue={(option, value) => {
                  if (option && value) {
                    return option?._id === value?._id;
                  }
                  return false;
                }}
                filterOptions={(options, _state) => options}
                value={ticketType}
                onChange={handleTicketTypeChange}
                sx={{ width: 180 }}
                disableClearable={true}
                renderInput={(params) => <TextField {...params} />}
              />
            </>
          )}
        </TableCell>
        <TableCell align="right">{elem?.source}</TableCell>
        <TableCell>
          {elem?.ticketExample?.reference ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={(_e) =>
                handleNavigateToProject(
                  elem?.ticketExample?.project?._id,
                  elem?.ticketExample?._id
                )
              }
              sx={{
                margin: 0,
                whiteSpace: 'nowrap',
                minWidth: 'auto',
              }}
            >
              {elem?.ticketExample?.reference}
            </Button>
          ) : null}
        </TableCell>
        <TableCell align="right">
          {!isEditableElement ? (
            <>
              <IconButton onClick={handleEditableElement} color={'primary'}>
                <ChangeCircleIcon />
              </IconButton>
            </>
          ) : (
            <>
              <IconButton
                onClick={handleConfirmModification}
                disabled={ticketType === null}
                color={'success'}
              >
                <CheckCircleIcon />
              </IconButton>
              <IconButton onClick={handleCancelModification} color={'error'}>
                <CancelIcon />
              </IconButton>
            </>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};

const CategorizationsList = ({ profile, contentTab, data, mutate }) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nom technique</TableCell>
              <TableCell>Nom</TableCell>
              <TableCell>Service</TableCell>
              <TableCell>Type de ticket</TableCell>
              <TableCell>Marketplace</TableCell>
              <TableCell>Ticket d&apos;exemple</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((categ) => {
              return (
                <CategorizationElem
                  key={categ?._id}
                  profile={profile}
                  contentTab={contentTab}
                  elem={categ}
                  mutate={mutate}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default CategorizationsList;
